import { createFileRoute } from "@tanstack/react-router";
import { getDiscoveriesBySlugs, type JourneyItem } from "@/lib/content.functions";
import { OCEAN_DESCENT } from "@/lib/descent";
import { hydrateNodes, journeySlugs } from "@/lib/journey-hydrate";
import { DescentEngine } from "@/components/DescentEngine";
import { usePageView } from "@/hooks/use-page-view";

const URL = "https://smartasaurus.com/descent";
const TITLE = "The Descent - scroll to the bottom of the ocean";
const DESC =
  "Scroll 10,935 metres from the surface to the Challenger Deep. Watch the light disappear, the pressure climb, and meet what lives at every depth.";

export const Route = createFileRoute("/descent")({
  loader: ({ context }) =>
    context.queryClient.ensureQueryData({
      queryKey: ["journey-items", OCEAN_DESCENT.key],
      queryFn: () => getDiscoveriesBySlugs({ data: { slugs: journeySlugs(OCEAN_DESCENT) } }),
    }),
  head: ({ loaderData }) => {
    const items = (loaderData as JourneyItem[] | undefined) ?? [];
    const img = items.find((i) => i.image_url)?.image_url ?? undefined;
    return {
      meta: [
        { title: TITLE },
        { name: "description", content: DESC },
        { property: "og:title", content: TITLE },
        { property: "og:description", content: DESC },
        { property: "og:url", content: URL },
        { property: "og:type", content: "website" },
        ...(img ? [{ property: "og:image", content: img }] : []),
        { name: "twitter:card", content: "summary_large_image" },
        { name: "twitter:title", content: TITLE },
        { name: "twitter:description", content: DESC },
        ...(img ? [{ name: "twitter:image", content: img }] : []),
      ],
      links: [{ rel: "canonical", href: URL }],
    };
  },
  component: DescentPage,
});

function DescentPage() {
  const items = Route.useLoaderData() as JourneyItem[];
  usePageView("descent");
  return <DescentEngine config={OCEAN_DESCENT} nodes={hydrateNodes(OCEAN_DESCENT, items)} shareUrl={URL} />;
}
